export default function CurrentBar({ isSelected }) {
  return (
    <div
      className={`flex h-9 flex-col justify-center border ${
        isSelected ? 'border-gray-800 dark:border-white' : 'border-gray-300 dark:border-gray-600'
      } px-4`}
    ></div>
  )
}
